import React, { useState, useEffect } from "react";
import CS from "../../../services/commonService";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import getBadgeClasses from "../../../util/badgeClass";
import Icon from "../../icons/index";
import ReactTooltip from "react-tooltip";
import Table from "../../common/table";
import SearchBox from "../../common/searchBox";
import moment from "moment";

import { useStore } from "../../../zustand/store";
import {
	useDownloadGifts,
	useGetAllGiftStatus,
} from "../../../queryHooks/useGifts";
import qs from "qs";
import { URL } from "../../../constants/URL";
import { modules } from "../../../constants/Modules";
import RenderUser from "../../common/User";
import { useGetPromoGifts } from "../../../queryHooks";

//	Pre-defined values
const columnKey = "promoGifts";
//	Component starts
const PromoGiftsTable = ({ userId }) => {
	//  Navigation
	const navigate = useNavigate();
	//const setLoading = useStore((state) => state.setLoading);
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);

	const [tableData, setTableData] = useState([]);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.RESTAURANT_COMPLETED_GIFTS]?.items_per_page || 10
	);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.RESTAURANT_COMPLETED_GIFTS]?.page || 1
	);
	const [giftsPayload, setGiftspayload] = useState(
		lastPageData?.[modules.RESTAURANT_COMPLETED_GIFTS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			filter: {
				gift_type: "RESTAURANT_PROMO_GIFT",
				recipient_id: userId,
			},
			sort: { created_at: "DESC" },
		}
	);

	const [statusOptions, setStatusOptions] = useState();

	const { data: dataGetGifts, isLoading } = useGetPromoGifts(
		qs.stringify(giftsPayload)
	);

	useEffect(() => {
		if (dataGetGifts && dataGetGifts.status === "success") {
			let respData = dataGetGifts?.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetGifts]);

	const { data: dataGetstatus } = useGetAllGiftStatus();

	useEffect(() => {
		if (dataGetstatus && dataGetstatus.data) {
			let _status = [];
			dataGetstatus.data.forEach((element) => {
				_status.push({
					label: element.value,
					value: element.id,
				});
			});
			setStatusOptions(_status);
		}
	}, [dataGetstatus]);

	const columns = [
		{
			label: "Gift Id",
			type: "string",
			// sort: true,
			path: "gift_id",
			alias: "data_gifts.gift_id",
		},
		{
			label: "Created Date",
			type: "date",
			sort: true,
			path: "created_at",
			filterDate: true,
			alias: "created_at",
			content: (item) => (
				<span>
					{item?.created_at ? getCurrentTimezoneDate(item.created_at) : null}
				</span>
			),
		},
		{
			label: "Expiry Date",
			type: "date",
			sort: true,
			path: "expires_at",
			filterDate: true,
			alias: "expires_at",
			content: (item) => (
				<span>
					{item?.expires_at
						? moment(item.expires_at).format("MM/DD/YYYY")
						: null}
				</span>
			),
		},
		{
			label: "User",
			type: "string",
			path: "recipient",
			content: (item) => (
				<>
					{item?.recipient?.is_guest_user ? (
						<Link
							onClick={() => {
								CS.guestUserAlert(
									item?.recipient?.mobile,
									item?.recipient?.email
								);
							}}
						>
							<RenderUser
								profileImageUrl={item?.recipient?.profile_image_url}
								firstName={item?.recipient?.first_name}
								lastName={item?.recipient?.last_name}
							/>
						</Link>
					) : (
						<Link
							to={{
								pathname: `${URL.onboarderedUsers}/${item?.recipient?.id}`,
								state: { key: "giftOrders" },
							}}
							onClick={() => {
								setLastPageData({
									[modules.RESTAURANT_COMPLETED_GIFTS]: giftsPayload,
								});
							}}
						>
							<RenderUser
								profileImageUrl={item?.recipient?.profile_image_url}
								firstName={item?.recipient?.first_name}
								lastName={item?.recipient?.last_name}
							/>
						</Link>
					)}
				</>
			),
		},
		{
			label: "Restaurant",
			type: "string",
			path: "data_restaurants.name",
			alias: "data_restaurants.name",
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.restaurants}/${item.restaurant_id}`,
						state: { key: "giftOrders" },
					}}
					onClick={() => {
						setLastPageData({
							[modules.RESTAURANT_COMPLETED_GIFTS]: giftsPayload,
						});
					}}
				>
					<RenderUser
						profileImageUrl={item?.restaurant?.profile_image_url}
						firstName={item?.restaurant?.name}
					/>
				</Link>
			),
		},

		{
			label: "Status",
			type: "boolean",
			filterOptions: statusOptions,
			aliasFilter: "status",
			content: (item) => (
				<p className={getBadgeClasses(item?.status?.value)}>
					{item?.status?.value}
				</p>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setLastPageData({
								[modules.RESTAURANT_COMPLETED_GIFTS]: giftsPayload,
							});
							navigate(`${URL.promoGifts}/${item?.id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	const {
		mutateAsync: downloadGifts,
		data: dataDownloadGifts,
		isLoading: isLoadingDownload,
	} = useDownloadGifts(giftsPayload);

	useEffect(() => {
		if (dataDownloadGifts) {
			saveAs(dataDownloadGifts.data?.filePath, "promoGifts.xlsx");
		}
	}, [dataDownloadGifts]);

	return (
		<>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[modules.RESTAURANT_COMPLETED_GIFTS]
														?.search?.["data_restaurants.name"]
												}
												search={(value) => {
													setPageNow(1);
													setGiftspayload({
														...giftsPayload,
														search: {
															"data_restaurants.name":
																!value && value === "" ? undefined : value,
															first_name:
																!value && value === "" ? undefined : value,
															last_name:
																!value && value === "" ? undefined : value,
															"data_gifts.gift_id":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												className="btn btn-default minW-md-0 btn-bg-white"
												onClick={() =>
													downloadGifts({
														...giftsPayload,
														timeZone: CS.getTimezone(),
													})
												}
											>
												{isLoadingDownload ? "Downloading..." : "Download"}
											</button>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								payload={giftsPayload}
								sortCol={(obj) => {
									setPageNow(1);
									setGiftspayload({
										...giftsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setGiftspayload({
										...giftsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setGiftspayload({
										...giftsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(giftsPayload.filter, obj);
										setPageNow(1);
										setGiftspayload({
											...giftsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setGiftspayload({
											...giftsPayload,
											filter: {
												...giftsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setGiftspayload({
										...giftsPayload,
										filter_date: dates && {
											...giftsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PromoGiftsTable;
